import axios from 'axios';
import { redirect } from 'react-router-dom';
import { clearToken, getToken } from 'utils/common/session';
import * as loginServices from 'services/login';
import { queryUserInfo } from 'hooks/auth/useUserInfo';

export const ensureUserInfoLoaded = async ({ queryClient, returnUrl }) => {
  const logoutAndRedirect = async () => {
    const refreshToken = localStorage.getItem('RefreshToken');
    if (refreshToken) {
      try {
        await loginServices.revokeToken({ token: refreshToken });
      } catch (error) {
        console.error('Failed to revoke token:', error);
      }
    }
    delete axios.defaults.headers.common['Authorization'];
    clearToken();
    throw redirect(`/login?returnUrl=${encodeURIComponent(returnUrl)}`);
  };

  try {
    // ✅ Check if token exists
    const accessToken = getToken();
    if (!accessToken) {
      return await logoutAndRedirect();
    }

    // ✅ Ensure axios header is set
    if (!axios.defaults.headers.common['Authorization']) {
      axios.defaults.headers.common['Authorization'] = `Bearer ${accessToken}`;
    }

    // ✅ Use React Query to fetch user info
    const userInfo = await queryUserInfo(queryClient);

    if (!userInfo) {
      console.error('Failed to get user info - returned null');
      return await logoutAndRedirect();
    }

    // ✅ Handle impersonation cleanup
    if (!userInfo.isImpersonating) {
      localStorage.removeItem('impersonate');
    }

    return { userInfo };
  } catch (error) {
    console.error('Error in ensureUserInfoLoaded:', error);

    // ✅ Don't redirect if it's already a redirect response
    if (error?.status === 302 || error instanceof Response) {
      throw error;
    }

    return await logoutAndRedirect();
  }
};
